import { TaskId } from "features/Resources/Task/models";
import { useMarkCompleteIfOpen, useTaskDetailQuery } from "features/Resources/Task/hooks";
import { SelectRoleForm, SelectRoleTaskActionForm } from "./SelectRole";
import { InputOnboardingPlanForm, InputOnboardingPlanTaskActionForm } from "./InputOnboardingPlan";
import { InputWorkEmailForm, InputWorkEmailTaskActionForm } from "./InputWorkEmail";
import { SendMessageTaskForm, SendMessageTaskActionForm } from "./SendMessage";

interface TaskActionFormProps {
  taskId: TaskId;
  onClose?: () => void;
}

export function TaskActionModalForm({ taskId, ...rest }: TaskActionFormProps) {
  // To be used within modals, requires the TaskActionContext & Provider
  // Note: Auto-complete is handled internally by each form component
  const { data: task } = useTaskDetailQuery(taskId);

  switch (task?.taskAction) {
    case "assign_buddy":
      return <SelectRoleTaskActionForm task={task} {...rest} />;
    case "create_onboarding_plan":
      return <InputOnboardingPlanTaskActionForm task={task} {...rest} />;
    case "create_email_account":
      return <InputWorkEmailTaskActionForm task={task} {...rest} />;
    case "send_message":
      return <SendMessageTaskActionForm task={task} {...rest} />;
    default:
      break;
  }
}

export function TaskActionForm({ taskId, ...rest }: TaskActionFormProps) {
  // To be used on the StepResolver, does not require the TaskActionContext & Provider
  const { data: task } = useTaskDetailQuery(taskId);
  const markCompleteIfOpen = useMarkCompleteIfOpen(task);
  switch (task?.taskAction) {
    case "assign_buddy":
      return <SelectRoleForm task={task} onSuccess={markCompleteIfOpen} {...rest} />;
    case "create_onboarding_plan":
      return <InputOnboardingPlanForm task={task} onSuccess={markCompleteIfOpen} {...rest} />;
    case "create_email_account":
      return <InputWorkEmailForm task={task} onSuccess={markCompleteIfOpen} {...rest} />;
    case "send_message":
      return <SendMessageTaskForm task={task} {...rest} />;
    default:
      break;
  }
}
